
export class UserProvider
{
    private id: string = "";

    public set Id(value: string)
    {
        this.id = value;
        
        window.localStorage.setItem("unique-chat-user-id", this.id);
    }

    public get Id(): string
    {
        if (this.id)
        {
            return this.id;
        }

        let uniqueClientId = window.localStorage.getItem("unique-chat-user-id") || "";

        if (!uniqueClientId)
        {
            uniqueClientId = "CU" + Math.random().toString(16).substring(2, 6).toUpperCase();

            window.localStorage.setItem("unique-chat-user-id", uniqueClientId);
        }

        this.id = uniqueClientId;

        return this.id;
    }

    public get Info(): string
    {
        try
        {
            const info = {
                ua: navigator.userAgent,
                platform: navigator.platform,
                lang: navigator.language,
                tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
                screen: `${screen.width}x${screen.height}x${screen.colorDepth}`,
                viewport: `${window.innerWidth}x${window.innerHeight}@${window.devicePixelRatio}`,
                touch: navigator.maxTouchPoints || 0,
            };

            return JSON.stringify(info);
        }
        catch (ex: any)
        {
            return "(no client info)";
        }
    }
}
